import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Body = styled.div`
  padding: ${space[4]} 0 ${space[5]};
`;

export const Grid = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${space[3]};
`;

export const Card = styled.li`
  margin: 0;
  padding: 0;
`;

export const CardButton = styled.button<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  padding: ${space[3]} ${space[4]};
  background: ${({ $active }) => ($active ? semantic.bg.surfaceSubtle : colors.white)};
  border: 1px solid ${({ $active }) => ($active ? semantic.border.default : semantic.border.subtle)};
  border-radius: ${layout.borderRadiusMd};
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const Name = styled.span`
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const Region = styled.span`
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;
